import React from 'lib/react';
import PropTypes from 'prop-types';
import { makeStyles } from 'lib/components';
import VirtualizedTable from 'commonComponents/virtualizedTable';

const useStyles = makeStyles((theme) => ({
  reportsTable: {
    borderCollapse: 'collapse',
    '& tbody>tr': {
      '&:not(.no-results)': {
        backgroundColor: theme.evPalette.charcoal[100],
      },
      '&>td': { border: 'none' },
    },
  },
  tableHeader: {
    '& th': {
      backgroundColor: theme.evPalette.salt[100],
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '27px',
      border: 'none',
      color: theme.evPalette.charcoal[700],
    },
    '& th:first-child': {
      paddingLeft: '24px',
    },
  },
  tableBody: {
    '& td:first-child': {
      paddingLeft: '24px',
    },
  },
}));

/** Component to render the Report details in table format for Order History Page */
function ReportsTable({
  reportDetailsList, fields, ...rest
}) {
  const classes = useStyles();
  return (
    <VirtualizedTable
      columns={fields}
      dataList={reportDetailsList}
      rowKey="rowKey"
      headerProps={{ className: classes.tableHeader }}
      bodyProps={{ className: classes.tableBody }}
      className={classes.reportsTable}
      {...rest}
    />
  );
}

ReportsTable.propTypes = {
  reportDetailsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  fields: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default ReportsTable;
